import React, { useState } from 'react';
import { useViewAnalyticsReport } from '../../hooks/reports/analytics';
import { useViewAppOpenCount } from '../../hooks/reports/appopencount';
import './AnalyticsReport.css';
import {
  MdAnalytics,
  MdTrendingUp,
  MdShare,
  MdOutlinePeopleAlt,
  MdOpenInNew,
  MdRemoveRedEye,
  MdExpandMore,
  MdExpandLess,
  MdPersonOff
} from 'react-icons/md';
import dist1 from '../../assets/images/categ1.png';

const AnalyticsReport = () => {
  const { data, loading, error } = useViewAnalyticsReport();
  const { data: appOpenData, isLoading: appOpenLoading, error: appOpenError } = useViewAppOpenCount();
  const [expandedDistributors, setExpandedDistributors] = useState({});
  const [expandedAppOpenDistributors, setExpandedAppOpenDistributors] = useState({});

  const toggleDistributor = (id) => {
    setExpandedDistributors(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const toggleAppOpenDistributor = (id) => {
    setExpandedAppOpenDistributors(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const getUserInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const getDistributorLogoUrl = (logo) => {
    if (!logo) return dist1;
    if (logo.startsWith("http://") || logo.startsWith("https://") || logo.startsWith("data:")) {
      return logo;
    }
    return `${process.env.REACT_APP_BASE_IMAGE}/${logo}`;
  };

  const getVideoUrl = (url) => {
    if (!url) return "#";
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    return `${process.env.REACT_APP_BASE_IMAGE}/${url}`;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <div className="loading-text">Loading platform analytics...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>Failed to load analytics data. Please check your connection or try again later.</p>
      </div>
    );
  }

  const viewedProducts = data?.monstViewedProducts || [];
  const sharedVideos = data?.mostSharedVideos || [];
  const distributorActivity = data?.distributorUserActivity || [];

  return (
    <div className="analytics-section">
      <h2 className="analytics-section-title">
        Analytics
      </h2>

      <div className="analytics-grid">
        {/* Most Viewed Products */}
        <div className="analytics-card">
          <div className="analytics-card-header">
            {/* <div className="analytics-card-icon" style={{ background: '#eff6ff', color: '#3b82f6' }}>
              // {/* <MdTrendingUp /> */}
            {/* </div> */}
            <h3>Top Viewed Products</h3>
          </div>
          <ul className="analytics-list" style={{ maxHeight: '360px', overflowY: 'auto', paddingRight: '4px' }}>
            {viewedProducts.length === 0 ? (
              <div className="no-data-placeholder">No product views recorded yet.</div>
            ) : (
              viewedProducts.map((product, idx) => (
                <li key={product._id || idx} className="analytics-item">
                  <div>
                    {idx + 1}
                  </div>
                  <div className="item-main-content">
                    <p className="item-title" title={product.title}>{product.title}</p>
                  </div>
                  <span className="badge-pill badge-blue">
                    <MdRemoveRedEye size={14} style={{ marginRight: '4px' }} /> {product.viewCount} views
                  </span>
                </li>
              ))
            )}
          </ul>
        </div>

        {/* Most Shared Videos */}
        <div className="analytics-card">
          <div className="analytics-card-header">
            {/* <div className="analytics-card-icon" style={{ background: '#faf5ff', color: '#a855f7' }}>
              <MdShare />
            </div> */}
            <h3>Top Viewed Videos</h3>
          </div>
          <ul className="analytics-list" style={{ maxHeight: '360px', overflowY: 'auto', paddingRight: '4px' }}>
            {sharedVideos.length === 0 ? (
              <div className="no-data-placeholder">No video shares recorded yet.</div>
            ) : (
              sharedVideos.map((video, idx) => (
                <li key={video.videoId || idx} className="analytics-item">
                  <div className="item-main-content">
                    <p className="item-title" title={video.videoTitle}>{video.videoTitle}</p>
                    <p className="item-subtitle" title={video.productTitle}>Product: {video.productTitle}</p>
                  </div>
                  <span className="badge-pill badge-purple" style={{ marginRight: '8px' }}>
                    {video.shareCount} Views
                  </span>
                  <a
                    href={getVideoUrl(video.videoUrl)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="video-action-btn"
                    title="View Video"
                  >
                    <MdOpenInNew size={16} />
                  </a>
                </li>
              ))
            )}
          </ul>
        </div>

        {/* Distributor User Activity */}
        <div className="analytics-card">
          <div className="analytics-card-header">
            {/* <div className="analytics-card-icon" style={{ background: '#ecfdf5', color: '#10b981' }}>
              <MdOutlinePeopleAlt />
            </div> */}
            <h3>Distributor with user  Activity</h3>
          </div>
          <ul className="analytics-list" style={{ maxHeight: '360px', overflowY: 'auto', paddingRight: '4px' }}>
            {distributorActivity.length === 0 ? (
              <div className="no-data-placeholder">No distributor activity found.</div>
            ) : (
              distributorActivity.map((dist, idx) => {
                const isActive = dist.loggedInUsersCount > 0;
                const hasLoggedOutUsers = dist.loggedOutUsers && dist.loggedOutUsers.length > 0;
                const isExpanded = !!expandedDistributors[dist._id];

                return (
                  <li key={dist._id || idx} className="analytics-item distributor-activity-item">
                    <div className="distributor-main-info">
                      <div className="distributor-left">
                        <img
                          src={getDistributorLogoUrl(dist.logo)}
                          alt={`${dist.companyName} logo`}
                          className="distributor-logo"
                          onError={(e) => { e.target.src = dist1; }}
                        />
                        <div className="item-main-content">
                          <p className="item-title" title={dist.companyName}>{dist.companyName}</p>
                          <p className="item-subtitle">{dist.country || 'Unknown Country'}</p>
                        </div>
                      </div>
                      <div className="distributor-right-actions">
                        <span className={isActive ? "badge-pill badge-green-active" : "badge-pill badge-gray-inactive"}>
                          <span className={`distributor-status-dot ${isActive ? 'active' : 'inactive'}`}></span>
                          {dist.loggedInUsersCount} / {dist.noOfUsers || 0} online
                        </span>
                        {hasLoggedOutUsers && (
                          <button
                            type="button"
                            className="toggle-offline-users-btn"
                            onClick={() => toggleDistributor(dist._id)}
                            title={isExpanded ? "Hide logged out users" : "Show logged out users"}
                          >
                            {isExpanded ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}
                          </button>
                        )}
                      </div>
                    </div>

                    {hasLoggedOutUsers && isExpanded && (
                      <div className="distributor-offline-users-list">
                        <div className="offline-users-header">
                          {/* <MdPersonOff size={14} className="offline-icon" /> */}
                          <span>Inactive users ({dist.loggedOutUsers.length}):</span>
                        </div>
                        <div className="offline-users-chips">
                          {dist.loggedOutUsers.map((user) => (
                            <div key={user._id} className="offline-user-chip" title={user.email}>
                              <span className="offline-user-initials">
                                {getUserInitials(user.name)}
                              </span>
                              <span className="offline-user-name">{user.name}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </li>
                );
              })
            )}
          </ul>
        </div>

        {/* App Opens by Distributor */}
        <div className="analytics-card">
          <div className="analytics-card-header">
            <h3>App Open Count Details</h3>
          </div>
          <ul className="analytics-list" style={{ maxHeight: '360px', overflowY: 'auto', paddingRight: '4px' }}>
            {appOpenLoading ? (
              <div className="no-data-placeholder">Loading app open details...</div>
            ) : appOpenError ? (
              <div className="no-data-placeholder">Error loading app open details.</div>
            ) : !appOpenData || appOpenData.length === 0 ? (
              <div className="no-data-placeholder">No app open records found.</div>
            ) : (
              appOpenData.map((dist, idx) => {
                const isExpanded = !!expandedAppOpenDistributors[dist.distributorId];
                const hasUsers = dist.users && dist.users.length > 0;

                return (
                  <li key={dist.distributorId || idx} className="analytics-item distributor-activity-item">
                    <div className="distributor-main-info">
                      <div className="distributor-left">
                        <img
                          src={getDistributorLogoUrl(dist.logo)}
                          alt={`${dist.distributorName} logo`}
                          className="distributor-logo"
                          onError={(e) => { e.target.src = dist1; }}
                        />
                        <div className="item-main-content">
                          <p className="item-title" title={dist.distributorName}>
                            {dist.distributorName}
                          </p>
                          <p className="item-subtitle">
                            {dist.country || 'Unknown Country'}
                          </p>
                        </div>
                      </div>
                      <div className="distributor-right-actions">
                        <span className="badge-pill badge-blue">
                          {dist.totalAppOpenedCount} opens
                        </span>
                        {hasUsers && (
                          <button
                            type="button"
                            className="toggle-offline-users-btn"
                            onClick={() => toggleAppOpenDistributor(dist.distributorId)}
                            title={isExpanded ? "Hide users" : "Show users"}
                          >
                            {isExpanded ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}
                          </button>
                        )}
                      </div>
                    </div>

                    {hasUsers && isExpanded && (
                      <div className="distributor-offline-users-list">
                        <div className="offline-users-header">
                          <span>Users ({dist.users.length}):</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {dist.users.map((user, uIdx) => (
                            <div key={uIdx} style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              background: '#ffffff',
                              border: '1px solid #f1f5f9',
                              borderRadius: '8px',
                              padding: '8px 12px'
                            }}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontSize: '13px', fontWeight: 600, color: '#334155' }}>
                                  {user.contactPerson}
                                </span>
                                <span style={{ fontSize: '11px', color: '#64748b' }}>
                                  {user.country || 'Unknown'}
                                </span>
                              </div>
                              <span className="badge-pill badge-purple" style={{ fontSize: '11px', padding: '3px 8px' }}>
                                {user.appOpenedCount} opens
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsReport;
